import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import MarqueeStrip from "@/components/landing/MarqueeStrip";
import AppsShowcase from "@/components/landing/AppsShowcase";
import Manifesto from "@/components/landing/Manifesto";
import FeaturesGrid from "@/components/landing/FeaturesGrid";
import Testimonials from "@/components/landing/Testimonials";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <main data-testid="landing-page" className="bg-[#FDFCFB]">
                <Seo
                  title="5ads.ai — Every ad channel. One AI brain."
                  description="A family of AI-powered ad managers. Facebook & Instagram today with social.5ads.ai, Google Search soon with search.5ads.ai. Your ads, on autopilot."
                  url="https://5ads.ai/"
                />
                <Nav />
                <Hero />
                <MarqueeStrip />
                <AppsShowcase />
                <Manifesto />
                <FeaturesGrid />
                <Testimonials />
                <ContactSection />
                <Footer />
              </main>
            }
          />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
